var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.636,
    height: 20.334,
    viewBox: "0 0 16.636 20.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_2",
    "data-name": "delete 2",
    transform: "translate(-2 -0.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M16.53,4.667a.924.924,0,0,0-.924.924V15.934a1.774,1.774,0,0,1-1.858,1.672H6.373a1.774,1.774,0,0,1-1.858-1.672V5.591a.924.924,0,0,0-1.848,0V15.934a3.621,3.621,0,0,0,3.706,3.52h7.375a3.621,3.621,0,0,0,3.706-3.52V5.591a.924.924,0,0,0-.924-.924Z",
    transform: "translate(0.258 1.545)",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M17.712,3.44h-3.7V1.591a.924.924,0,0,0-.924-.924H7.545a.924.924,0,0,0-.924.924V3.44h-3.7a.924.924,0,1,0,0,1.848H17.712a.924.924,0,0,0,0-1.848Zm-9.242,0V2.516h3.7V3.44Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M7.848,13.394V6.924A.924.924,0,1,0,6,6.924v6.469a.924.924,0,0,0,1.848,0Z",
    transform: "translate(1.545 2.06)",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M10.515,13.394V6.924a.924.924,0,1,0-1.848,0v6.469a.924.924,0,1,0,1.848,0Z",
    transform: "translate(2.576 2.06)",
    fill: "#c19444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.157fc9bd1d720a4f41918447bfca377d.svg";
export { ForwardRef as ReactComponent };